module.exports = __webpack_public_path__ + "img/start.d7389b49.svg";